import { Adapter as t } from "../../../../api/adapter.js";
import { CustomizationServiceModel as m } from "./services.model.js";
class n extends t {
  adapt(e) {
    return new m({
      menu: e.menu,
      menuName: e.menu_name,
      status: e.status
    });
  }
  serialize(e) {
  }
}
export {
  n as CustomizationServiceAdapter
};
//# sourceMappingURL=services.adapter.js.map
